import { getCookie, setCookie } from '@helpers/cookies'
import generateBcomUrl from '@helpers/generateBcomUrl'
import generateExpediaUrl from '@helpers/generateExpediaUrl'
import generateHotelscomUrl from '@helpers/generateHotelscomUrl'

const MOTIVATED_COUNTRIES = ['US', 'GB']

const MOTIVATED_TYPES = [
	'property',
	'table',
	'form',
	'searchform',
	'reviews',
	'website',
	'rooms',
]

export const isMotivated = type => {
	return (
		MOTIVATED_TYPES.includes(type) &&
		MOTIVATED_COUNTRIES.includes(shared.options.user.country_code)
	)
}

export const generateMotivatedPartnerLink = partnerRedirectParams => {
	const motivatedStep = +getCookie('motivated-step')
	switch (motivatedStep) {
		case 0:
			return generateBcomUrl(partnerRedirectParams)
		case 1:
			return generateExpediaUrl(partnerRedirectParams)
		case 2:
			return generateHotelscomUrl(partnerRedirectParams)
		default:
			return generateBcomUrl(partnerRedirectParams)
	}
}

export const setNextMotivatedStep = () => {
	const motivatedStep = +getCookie('motivated-step') || 0
	setCookie('motivated-step', motivatedStep + 1)
}
